// Shared navigation-related types and helpers
// Central definition of Dashboard category keys to avoid string typos.

export type CategoryKey =
  | 'order'
  | 'product'
  | 'purchase'
  | 'expiry'
  | 'promotion'
  | 'analytics'
  | 'settings'
  | 'hq';

/** Feature key for HQ module; must match company_feature_flags.feature_key */
export const HQ_FEATURE_KEY = 'headquarters_module';

export const DASHBOARD_CATEGORIES: CategoryKey[] = [
  'order',
  'product',
  'purchase',
  'expiry',
  'promotion',
  'analytics',
  'settings',
  'hq',
];

